import styled from "styled-components";

export const Heading = styled.div`
  text-align: center;
  color: #000;
  font-family: Poppins;
  font-size: 1.125em;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 5em;
`;
export const Input = styled.input`
  width: 19.5em;
  height: 2.5em;
  margin-bottom: 0.9em;
  border-radius: 0.5em;
  border: 1px solid #8e8e8e;
  background: #fff;
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 0.5em 0.94em;
  ::placeholder {
    color: #c8c8c8;
    font-family: Poppins;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;
export const Info = styled.div`
  color: #666;
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 1.9em;
  text-align: center;
`;
